import styled from 'styled-components';

import { Flex } from '../../grid';
import { NavLink as SharedNavLink } from '../../nav-link';

const NavItemStyles = styled(Flex)`
  display: flex;
  white-space: nowrap;
  justify-content: space-between;
`;

const NavLink = styled(SharedNavLink)`
  ${NavItemStyles};

  &:hover {
    background: ${({ theme }) => theme.colors.warmWhite3};
  }
`;

export { NavLink };
